export const modalMotion = {
  initial: { top: 130, left: '50%', opacity: 0, translateX: '-50%' },
  animate: { top: 80, left: '50%', opacity: 1, translateX: '-50%' },
  exit: {},
};
